import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../../../modules/material/material.module";
import { TranslateModule } from "@ngx-translate/core";

import { AddContactModule } from "../../contact/add-contact.module";
import { OrgCallHistoryComponent } from "./org-call-history.component";
import { NewCallModule } from "../../shared/components/newCall/new-call.module";
import { TableModule } from "../../shared/components/table/onsip-table.module";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { OrgCallHistoryRoutingModule } from "./org-call-history-routing.module";

@NgModule({
  imports: [
    CommonModule,
    AddContactModule,
    ReactiveFormsModule,
    NewCallModule,
    PipesModule,
    MaterialModule,
    TranslateModule,
    TableModule,
    OrgCallHistoryRoutingModule
  ],
  declarations: [OrgCallHistoryComponent]
})
export class OrgCallHistoryModule {}
